<template>
  <div class="left-content bsb">
    <div class="user-detail flex-col aic lh1">
      <div class="avatar por bsb flex aic jcc" :class="{vip: userInfo.is_web_vip}">
        <div class="poa mine-ico is-vip dn"></div>
        <img v-df-avatar :src="userInfo.icon" alt="" class="avatar-inner vam w100"/>
      </div>
      <div class="realname">{{userInfo.realname || userInfo.nickname || ('用户' + userInfo.username)}}</div>
      <div class="username"><span class="label">账号ID：</span>{{userInfo.username}}</div>
      <div class="phone"><span class="label">手机号：</span>{{userInfo.phone}}</div>
      <div class="pay-vip tac csp" @click="ShowVip()">{{userInfo.is_web_vip ? '续费' : '开通'}}会员</div>
    </div>
    <div class="page-list">
      <div class="user-page-item bsb w100 flex aic csp" @click="linkTo(page)"
           :class="{active: active === page.type}"
           v-for="(page, i) in pageList" :key="i">
        <i class="mine-ico" :class="page.ico || page.type"></i>
        <span>{{page.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "ViewLeft",
    computed: {
      ...mapGetters(['userInfo']),
      active() {
        let curr = this.pageList.find(e => ~this.$route.path.indexOf(e.type.split('/')[0]));
        return curr && curr.type;
      },
    },
    watch: {
      active() {
        document.getElementById('app').scrollTop = 0;
      },
    },
    data() {
      return {
        pageList: [
          {title: '播放记录', id: 1, type: 'play'},
          {title: '我的收藏', id: 2, type: 'collection'},
          {title: '我的关注', id: 3, type: 'follow'},
          {title: '已购课程', id: 4, type: 'course'},
          {title: 'VIP会员', id: 5, type: 'vip/my', ico: 'vip'},
          {title: '设置', id: 6, type: 'setting'},
        ],
      };
    },
    methods: {
      linkTo(item) {
        this.$router.push('/user/' + item.type);
      },
    }
  }
</script>

<style scoped lang="less">
  .left-content {
    padding: 36px 20px;
    width: 287px;
    height: 639px;
    background: url(../../assets/images/user/left_bg.png) no-repeat top left / 100%, #fff;
    border-radius: 8px;
  }

  .user-detail {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #eee;
    .avatar {
      margin-bottom: 18px;
      width: 64px;
      height: 64px;
      border: 1px solid #eee;
      border-radius: 50%;
      background-color: #fff;
      .avatar-inner {
        border-radius: 50%;
      }
      &.vip {
        border: 2px solid #FFC264;
        .is-vip {
          display: block;
          top: -11px;
          left: -3px;
        }
      }
    }
    .realname {
      margin-bottom: 22px;
      color: #212730;
      font-size: 16px;
    }
    .username,
    .phone {
      margin-bottom: 16px;
      font-size: 12px;
      color: #333f4e;
    }
    .label {
      color: #999fa6;
    }
    .pay-vip {
      margin-top: 8px;
      width: 90px;
      height: 30px;
      font-size: 14px;
      color: #b9732e;
      line-height: 30px;
      background: linear-gradient(-45deg, #FFD28C, #FFD99E);
      border-radius: 30px;
      &:hover {
        background: #FDCC81;
      }
    }
  }

  .user-page-item {
    padding-left: 16px;
    height: 44px;
    line-height: 44px;
    border-radius: 4px;
    border-left: 4px solid transparent;
    color: #959595;
    font-size: 16px;

    &:hover,
    &.active {
      color: #1177ff;
      &.active {
        background-color: #ECF4FF;
        border-left-color: #1177FF;
      }
      .mine-ico {
        &:after {
          background-color: #1177ff;
        }
      }
    }
  }
</style>